import { useQuery } from "react-query";

import { makeRequest } from "../../util";

export type ScanByTrackerDomains = {
  id: string;
  domain: string;
  trackerDomains: string[];
  startedAt: Date;
  isComplete: boolean;
  internal: boolean;
};

type AdminQueryWTMScansByTrackerDomainsResponse = {
  scans: ScanByTrackerDomains[];
};

export default function useAdminQueryWTMScansByTrackerDomains(
  trackerDomains: string[],
  fromDate: Date,
  toDate: Date,
  onSuccess: () => void = () => {}
) {
  return useQuery<ScanByTrackerDomains[]>(
    [
      "admin_query_wtm_scans_by_tracker_domains",
      trackerDomains,
      fromDate,
      toDate,
    ],
    async () => {
      const res = await makeRequest<AdminQueryWTMScansByTrackerDomainsResponse>(
        "admin_query_wtm_scans_by_tracker_domains",
        { trackerDomains, fromDate, toDate }
      );

      return res.data.scans
        .map((scan) => ({
          ...scan,
          startedAt: new Date(scan.startedAt),
        }))
        .sort((a, b) => {
          const byDomain = a.domain.localeCompare(b.domain);
          if (byDomain === 0) {
            return b.startedAt.getTime() - a.startedAt.getTime();
          }

          return byDomain;
        });
    },
    {
      onSuccess,
    }
  );
}
